export default function Footer() {
	return (
		<footer>
			<div>© 2022 by Me</div>
		</footer>
	);
}
